var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasssssword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 217.3 197.8",
    style: {
      enableBackground: "new 0 0 217.3 197.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EBFAE3;}\n\t.st1{fill:#CCCBCA;}\n\t.st2{fill:#E6E5E5;}\n\t.st3{fill:#30363D;}\n\t.st4{fill:#31353A;}\n\t.st5{fill:#474F59;}\n\t.st6{fill:#F6F8FB;}\n\t.st7{fill:#6FBB44;}\n\t.st8{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 108.6,
    cy: 99,
    r: 98.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.2,151.7c8.2,3.6,17.4,5.6,27,5.6h163c9.6,0,18.7-2,27-5.6H0.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: 148.3,
    className: "st2",
    width: 217,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.8,
    y: 148.3,
    className: "st3",
    width: 37.6,
    height: 1.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M195.2,42.2c-1.1-1.1-2.6-1.7-4.1-1.7H26.2c-1.5,0-3,0.6-4.1,1.7c-1.1,1.1-1.7,2.6-1.7,4.1v101.9H197V46.4 C196.9,44.9,196.3,43.4,195.2,42.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M111.1,45.1c0,1.4-1.1,2.5-2.5,2.5c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5 C110,42.5,111.1,43.6,111.1,45.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M109.7,45.1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1,1.1-1 C109.2,43.9,109.7,44.5,109.7,45.1z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 49.6,
    className: "st6",
    width: 158.2,
    height: 98.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M108.6,61c-10.3,0-18.7,8.3-18.7,18.6v11.1h5.9V79.6c0-6.9,5.7-12.7,12.7-12.7c7,0,12.7,5.7,12.7,12.7 v11.1h5.9V79.6C127.3,69.3,119,61,108.6,61z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.1,
    y: 90.7,
    className: "st7",
    width: 51.1,
    height: 38
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.1,
    y: 128.8,
    className: "st3",
    width: 51.1,
    height: 8.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.7,
    y: 104.3,
    className: "st8",
    width: 41.8,
    height: 10.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M94.5,111.7c-1,0-1.9-0.8-1.9-1.9c0-1,0.8-1.9,1.9-1.9c1,0,1.9,0.9,1.9,1.9S95.5,111.7,94.5,111.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M101.6,111.7c-1,0-1.9-0.8-1.9-1.9c0-1,0.8-1.9,1.9-1.9c1,0,1.9,0.9,1.9,1.9S102.6,111.7,101.6,111.7z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M108.6,111.7c-1,0-1.9-0.8-1.9-1.9c0-1,0.9-1.9,1.9-1.9s1.9,0.9,1.9,1.9S109.7,111.7,108.6,111.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M115.7,111.7c-1,0-1.9-0.8-1.9-1.9c0-1,0.8-1.9,1.9-1.9c1,0,1.9,0.9,1.9,1.9S116.8,111.7,115.7,111.7z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M122.8,111.7c-1,0-1.9-0.8-1.9-1.9c0-1,0.8-1.9,1.9-1.9c1,0,1.9,0.9,1.9,1.9 C124.7,110.7,123.8,111.7,122.8,111.7z"
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M175.1,157.3c-3.2,0-5.9-2.6-5.9-5.9v-73c0-3.2,2.6-5.9,5.9-5.9h34.4c3.2,0,5.9,2.6,5.9,5.9v73 c0,3.2-2.6,5.9-5.9,5.9L175.1,157.3L175.1,157.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M197.4,151.2c0,0.8-0.6,1.4-1.4,1.4h-7.4c-0.8,0-1.4-0.6-1.4-1.4v-0.6c0-0.8,0.6-1.4,1.4-1.4h7.4 c0.8,0,1.4,0.6,1.4,1.4V151.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M198.5,79c0,0.3-0.3,0.6-0.6,0.6h-11.3c-0.3,0-0.6-0.3-0.6-0.6v-0.2c0-0.3,0.3-0.6,0.6-0.6h11.3 c0.3,0,0.6,0.3,0.6,0.6V79z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.6,
    y: 85.3,
    className: "st6",
    width: 39.5,
    height: 59.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M208.1,114.9c0,8.8-7,15.8-15.8,15.8s-15.8-7-15.8-15.8s7-15.8,15.8-15.8 C201.1,99.1,208.1,106.1,208.1,114.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "183.8,115 185.4,113.4 189.9,117.9 199.4,108.5 201,110.1 189.9,121.2  "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasssssword);
export default __webpack_public_path__ + "static/media/passsssword.1c33d691b88c9ce022bc094e368336a3.svg";
export { ForwardRef as ReactComponent };